import React from 'react';
import { useTranslation } from 'react-i18next';
import './Blog.css';

const Blog = () => {
  const { t } = useTranslation();
  const blogPosts = t('blog.posts', { returnObjects: true });

  return (
    <section className="blog">
      <div className="container">
        <div className="blog-header" data-aos="fade-up">
          <h2 className="blog-title">{t('blog.title')}</h2>
        </div>
        <div className="blog-posts">
          {blogPosts.map((post, index) => (
            <article key={index} className="blog-post" data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="post-image">
                <picture>
                  <source type="image/webp" srcSet={`/images/dep_0${index+1}.webp`} />
                  <img src={`/images/dep_0${index+1}.png`} alt={post.title} />
                </picture>
              </div>
              <div className="post-content">
                <h3 className="post-title">{post.title}</h3>
                <p className="post-excerpt">{post.excerpt}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;


